import { Component, OnInit } from '@angular/core';
import { MetaService } from '../../../services/meta-service.service';
@Component({
  selector: 'app-motors',
  templateUrl: './motors.component.html',
  styleUrls: ['./motors.component.scss']
})
export class MotorsComponent implements OnInit {

  constructor(private metaService: MetaService) { }

  ngOnInit(): void {
    this.metaService.setCanonicalURL();
  }

}
